import { FaPlay } from 'src/components/icon';
import { useDateUpdate } from 'src/utils/helper';
import styled from 'styled-components';

const CardH = ({ data, number }) => {
  const dateUpdate = useDateUpdate(data?.published_at);
  const category = data?.section ? data?.section?.th : 'ข่าว';
  return (
    <CardWrapper className='card-video-h'>
      <div className='video-number'>{number}</div>
      <div className='play-card-live'>
        <FaPlay className='position-absolute button-card-live' />
        <div className='box-live'>
          <img className='video-thumbnail' src={data?.image} alt={data?.title} />
        </div>
      </div>
      <div className='video-info'>
        <h2>{data?.title}</h2>
        <div className='d-flex video-meta'>
          <div>
            <span className='video-duration'>
              {category} {data?.duration === null ? '' : data?.duration?.slice(2, -1).replace('M', ':')}
            </span>
            {data.published_at && <span className='video-date'> | {dateUpdate}</span>}
          </div>
          <div>
            <span className='video-remore'>
              <a href={data.link}> อ่านต่อ...</a>
            </span>
          </div>
        </div>
      </div>
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  h2 {
    margin: 0;
  }
  display: block;
  overflow: hidden;
  cursor: pointer;
  padding: 5px;
  .video-number {
    float: left;
    width: 20px;
    text-align: left;
    line-height: 46px;
    font-size: 11px;
    color: #bbbbbb;
  }
  .play-card-live {
    position: relative;
    &::before {
      content: '';
      z-index: 1;
      position: absolute;
      background: #b8b8b896;
      width: 30px;
      border-radius: 50px;
      height: 30px;
      transform: translate(42px, 19px);
    }
    .button-card-live {
      z-index: 2;
      position: absolute;
      font-size: 14px;
      color: #ffffff;
      transform: translate(51px, 26px);
    }
    .box-live {
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 20px;
        width: 100%;
        height: 65px;
        max-width: 115px;
        opacity: 0.6;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 1) 100%);
      }
    }
  }
  .video-thumbnail {
    width: 100%;
    height: 65px;
    max-width: 115px;
    object-fit: cover;
    float: left;
    margin-right: 10px;
  }

  .video-info {
    h2 {
      color: #000;
      font-size: 14px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      overflow: hidden;
      @media (max-width: 480px) {
        font-size: 12px;
      }
    }
  }

  .video-meta {
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .video-duration {
    font-size: 11px;
    color: rgba(0, 170, 44);
    margin-top: 3px;
    line-height: 1;
  }

  .video-date {
    font-size: 11px;
    color: #5a5a5ac0;
    margin-top: 3px;
    line-height: 1;
  }

  .video-remore {
    font-size: 11px;
    color: #5a5a5ac0;
    margin-top: 3px;
    line-height: 1;
    a {
      color: #5a5a5ac0;
    }
    &:hover {
      a {
        color: rgba(0, 170, 44);
      }
    }
  }
`;

export default CardH;
